// extracted by mini-css-extract-plugin
export default {"inputArea":"styles_inputArea__dZdjR","input":"styles_input__SIvBr","icon":"styles_icon__TUWmh"};